// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"90c51f28","602":"038c6d9e"}[chunkId] + ".chunk.css";
};